import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL ?? '/'),
  linkActiveClass: 'active-link',
  routes: [
    {
      name: 'home',
      path: '/',
      component: () => import('./views/GameListView.vue'),
    },
    // Games
    {
      name: 'instant-win',
      path: '/instant-win/:instantWinCode',
      component: () => import('./views/GameView.vue'),
    },
    {
      name: 'instant-wins-play',
      path: '/instant-win/:instantWinCode/play',
      component: () => import('./views/GameView.vue'),
    },
    {
      name: 'instant-wins-demo',
      path: '/instant-win/:instantWinCode/demo',
      component: () => import('./views/GameView.vue'),
    },
    {
      name: 'entries',
      path: '/entries',
      component: () => import('./views/PrizesView.vue'),
    },
    {
      name: 'entry-details',
      path: '/entries/:code',
      component: () => import('./views/EntryDetailsView.vue'),
    },
    {
      name: 'winners',
      path: '/winners',
      component: () => import('./views/WinnersView.vue'),
    },
    {
      name: 'about',
      path: '/about',
      component: () => import('./views/AboutView.vue'),
    },
    /* These need to be here because FAQ content contains these links */
    {
      name: 'prizes',
      path: '/prizes',
      redirect: '/',
    },
    {
      name: 'instant-win-terms-and-conditions',
      path: '/instant-win-terms-and-conditions/:instantWinCode',
      redirect: '/',
    },
    {
      name: 'members-zone',
      path: '/members-zone',
      redirect: '/',
    },
    {
      name: 'terms-and-conditions',
      path: '/terms-and-conditions',
      redirect: '/',
    },
    {
      name: 'rewards',
      path: '/rewards',
      redirect: '/',
    },
  ],
})

export default router
